import { fontSans, hexToRgba, SENTINEL_DEMO_URL } from './theme'

const linkStyle: React.CSSProperties = {
  fontFamily: fontSans,
  fontSize: '0.82rem',
  color: 'rgba(255,255,255,0.4)',
  textDecoration: 'none',
  transition: 'color 0.2s ease',
  display: 'inline-flex',
  alignItems: 'center',
  gap: '7px',
  padding: '3px 0',
}

const columnTitle: React.CSSProperties = {
  fontFamily: fontSans,
  fontSize: '0.72rem',
  fontWeight: 600,
  letterSpacing: '0.1em',
  textTransform: 'uppercase',
  color: 'rgba(255,255,255,0.55)',
  marginBottom: '0.75rem',
}

export function Footer() {
  return (
    <footer
      style={{
        background: '#060a16',
        borderTop: '1px solid rgba(255,255,255,0.06)',
        padding: '3.5rem 2rem 2.5rem',
      }}
    >
      <div
        style={{
          maxWidth: '1280px',
          margin: '0 auto',
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          gap: '2.5rem',
        }}
      >
        {/* Logo + copyright */}
        <div style={{ maxWidth: '300px' }}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              marginBottom: '0.75rem',
            }}
          >
            <div
              style={{
                width: '24px',
                height: '24px',
                borderRadius: '6px',
                background: 'linear-gradient(135deg, #4A90E2, #9D4EDD)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
              }}
            >
              <svg width="13" height="13" viewBox="0 0 18 18" fill="none">
                <circle cx="9" cy="9" r="3" fill="white" />
                <circle cx="3" cy="3" r="1.5" fill="white" opacity="0.7" />
                <circle cx="15" cy="3" r="1.5" fill="white" opacity="0.7" />
                <circle cx="3" cy="15" r="1.5" fill="white" opacity="0.7" />
                <circle cx="15" cy="15" r="1.5" fill="white" opacity="0.7" />
              </svg>
            </div>
            <span
              style={{
                fontFamily: fontSans,
                fontWeight: 700,
                fontSize: '0.95rem',
                color: '#ffffff',
                letterSpacing: '-0.02em',
              }}
            >
              Synkrasis<span style={{ color: '#4A90E2' }}>.ai</span>
            </span>
          </div>
          <p
            style={{
              fontFamily: fontSans,
              fontSize: '0.8rem',
              color: 'rgba(255,255,255,0.35)',
              margin: '0 0 1rem',
              lineHeight: 1.6,
            }}
          >
            The Agentic Data Engineering Company. One governance kernel — the
            platform, Ontext and Sentinel.
          </p>
          <p
            style={{
              fontFamily: fontSans,
              fontSize: '0.78rem',
              color: 'rgba(255,255,255,0.3)',
              margin: 0,
            }}
          >
            © 2026 Synkrasis.ai. All rights reserved.
          </p>
        </div>

        {/* Products column */}
        <div>
          <div style={columnTitle}>Products</div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
            }}
          >
            <a
              href="#platform"
              style={linkStyle}
              onMouseEnter={(e) => (e.currentTarget.style.color = '#4A90E2')}
              onMouseLeave={(e) =>
                (e.currentTarget.style.color = 'rgba(255,255,255,0.4)')
              }
            >
              <Dot color="#4A90E2" /> SynKrasis Platform
            </a>
            <a
              href="#ontext"
              style={linkStyle}
              onMouseEnter={(e) => (e.currentTarget.style.color = '#9D4EDD')}
              onMouseLeave={(e) =>
                (e.currentTarget.style.color = 'rgba(255,255,255,0.4)')
              }
            >
              <Dot color="#9D4EDD" /> Ontext — Open Source
            </a>
            <a
              href="#sentinel"
              style={linkStyle}
              onMouseEnter={(e) => (e.currentTarget.style.color = '#2DD4BF')}
              onMouseLeave={(e) =>
                (e.currentTarget.style.color = 'rgba(255,255,255,0.4)')
              }
            >
              <Dot color="#2DD4BF" /> Sentinel — PII Compliance
            </a>
            <a
              href={SENTINEL_DEMO_URL}
              target="_blank"
              rel="noopener noreferrer"
              style={linkStyle}
              onMouseEnter={(e) => (e.currentTarget.style.color = '#2DD4BF')}
              onMouseLeave={(e) =>
                (e.currentTarget.style.color = 'rgba(255,255,255,0.4)')
              }
            >
              <Dot color="#2DD4BF" /> Sentinel Live Demo ↗
            </a>
          </div>
        </div>

        {/* Company column */}
        <div>
          <div style={columnTitle}>Company</div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
            }}
          >
            {[
              { label: 'Why SynKrasis', href: '#problem' },
              { label: 'Kaavya AI Agent', href: '#kaavya' },
              { label: 'About Us', href: '#company' },
              { label: 'Get a Demo', href: '#demo' },
            ].map((l) => (
              <a
                key={l.label}
                href={l.href}
                style={linkStyle}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.color = 'rgba(255,255,255,0.8)')
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.color = 'rgba(255,255,255,0.4)')
                }
              >
                {l.label}
              </a>
            ))}
          </div>
        </div>

        {/* Social icons */}
        <div>
          <div style={columnTitle}>Connect</div>
          <div style={{ display: 'flex', gap: '0.75rem' }}>
            {/* LinkedIn */}
            <a
              href="https://linkedin.com"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
              style={{
                width: '36px',
                height: '36px',
                borderRadius: '8px',
                background: 'rgba(255,255,255,0.04)',
                border: '1px solid rgba(255,255,255,0.08)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: 'rgba(255,255,255,0.4)',
                textDecoration: 'none',
                transition: 'all 0.2s ease',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.color = '#4A90E2'
                e.currentTarget.style.borderColor = 'rgba(74, 144, 226, 0.3)'
                e.currentTarget.style.background = 'rgba(74, 144, 226, 0.1)'
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.color = 'rgba(255,255,255,0.4)'
                e.currentTarget.style.borderColor = 'rgba(255,255,255,0.08)'
                e.currentTarget.style.background = 'rgba(255,255,255,0.04)'
              }}
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6zM2 9h4v12H2z" />
                <circle cx="4" cy="4" r="2" />
              </svg>
            </a>

            {/* Twitter/X */}
            <a
              href="https://twitter.com"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Twitter / X"
              style={{
                width: '36px',
                height: '36px',
                borderRadius: '8px',
                background: 'rgba(255,255,255,0.04)',
                border: '1px solid rgba(255,255,255,0.08)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: 'rgba(255,255,255,0.4)',
                textDecoration: 'none',
                transition: 'all 0.2s ease',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.color = '#4A90E2'
                e.currentTarget.style.borderColor = 'rgba(74, 144, 226, 0.3)'
                e.currentTarget.style.background = 'rgba(74, 144, 226, 0.1)'
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.color = 'rgba(255,255,255,0.4)'
                e.currentTarget.style.borderColor = 'rgba(255,255,255,0.08)'
                e.currentTarget.style.background = 'rgba(255,255,255,0.04)'
              }}
            >
              <svg
                width="15"
                height="15"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </footer>
  )
}

function Dot({ color }: { color: string }) {
  return (
    <span
      style={{
        width: '5px',
        height: '5px',
        borderRadius: '50%',
        background: color,
        boxShadow: `0 0 6px ${hexToRgba(color, 0.7)}`,
        flexShrink: 0,
      }}
    />
  )
}
